import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Su pedido (coste mensual)',
    main: 'Su suscripción',
    billing_settings: 'Configuración de facturación',
  },
  form: {
    billing_mode: {
      label: 'Modo de facturación',
    },
    has_trial: {
      label: 'Añadir días de prueba gratuitos',
    },
    trial_days: {
      label: '¿Cuántos días de prueba desea añadir?',
      placeholder: '21',
      validation: {
        required: 'Los días de prueba son obligatorios',
        min: '{{value}} es el valor mínimo para los días de prueba',
        max: '{{value}} es el valor máximo para los días de prueba',
      },
    },
  },
  fields: {
    created_at: 'Creado el <strong>{{date}}</strong> por <strong>{{manager}}</strong>',
    updated_at: 'Última actualización el <strong>{{date}}</strong> por <strong>{{manager}}</strong>',
    trial_ends_at: 'En prueba hasta <strong>{{date}}</strong>',
    trial_days:
      'El periodo de prueba de {{trialDays}} días comienza en la fecha de lanzamiento; se le cobrará al finalizar',
    resumable_until: 'Reanudable hasta <strong>{{date}}</strong>',
    ended_at: 'Finalizada el <strong>{{date}}</strong>',
    next_bill_at: 'Próxima factura el <strong>{{date}}</strong>',
    product: 'Producto',
    quantity: 'Cantidad',
    price: 'Precio neto',
    tax: 'Impuesto',
    amount: 'Importe',
    net: 'Neto',
    tax_percentage: 'Impuesto {{rate}}%',
    total: 'Cargo total mensual',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Cargo desde método de pago',
    [BillingMode.InternalInvoicing]: 'Cargo desde ventas',
  },
  labels: {
    included: 'incluido',
    sales_based_discount:
      'Hay un artículo en el carrito con precio variable; el precio real se calculará al crear/actualizar la suscripción según las métricas de ventas del último mes',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    resume: 'Reanudar',
  },
  modals: {
    cancel_subscription: {
      title: '¿Cancelar la suscripción de {{company}}?',
      description:
        'Se cancelará la suscripción seleccionada, incluyendo <strong>{{products}}</strong> (<strong>{{total}} importe total</strong>). La suscripción puede reanudarse hasta <strong>{{billingAnchor}}</strong> si el cliente cambia de opinión. Si no se reanuda antes, deberá crearse una nueva suscripción',
    },
    resume_subscription: {
      title: '¿Reanudar la suscripción de {{company}}?',
      description:
        'Se reanudará la suscripción seleccionada, incluyendo <strong>{{products}}</strong>. Al restaurante se le cobrará <strong>{{total}}</strong> cada mes a partir de <strong>{{billingAnchor}}</strong>',
    },
  },
  toasts: {
    cancel_subscription:
      'Si desea cancelar su suscripción, contacte por teléfono o correo electrónico con su persona de contacto de {{provider}}. Su contacto cancelará la suscripción de inmediato.',
    failed_to_cancel_subscription: 'Algo salió mal al cancelar la suscripción. Contacte con soporte técnico',
    resume_subscription:
      'Si desea reanudar su suscripción, contacte por teléfono o correo electrónico con su persona de contacto de {{provider}}. Su contacto reanudará la suscripción de inmediato.',
    failed_to_resume_subscription: 'Algo salió mal al reanudar la suscripción. Contacte con soporte técnico',
  },
};
